import React from 'react'
import RankedScoreboard from '../containers/RankedScoreboard'
import ChangeWeek from '../containers/ChangeWeek'
import TribalCounter from '../containers/TribalCounter'
import StandingBoard from '../containers/StandingBoard'

const App = () => (
  <div>
    <div className="mdl-layout mdl-js-layout mdl-layout--fixed-header">
    <header className="mdl-layout__header">
      <div className="mdl-layout__header-row">
        <ChangeWeek actionType="FIRST_WEEK"><i className="material-icons">first_page</i></ChangeWeek>
        <ChangeWeek actionType="LAST_WEEK"><i className="material-icons">chevron_left</i></ChangeWeek>
        <div className="mdl-layout-spacer"></div>
        <TribalCounter />
        <div className="mdl-layout-spacer"></div>

        <nav className="mdl-navigation">
          <ChangeWeek actionType="NEXT_WEEK"><i className="material-icons">chevron_right</i></ChangeWeek>
          <ChangeWeek actionType="FINAL_WEEK"><i className="material-icons">last_page</i></ChangeWeek>
        </nav>
      </div>
    </header>
    <main className="mdl-layout__content">
      <div className="page-content">
        <h1>Munslow Survivor</h1>
        <h2>Season 44</h2>

        <div className="container">
          <div className="navBox">
            <div>

            </div>

            <div>

            </div>
          </div>
        </div>
        <div className="container">
            <RankedScoreboard title="winners"/>
            <StandingBoard />
            <RankedScoreboard title="losers" />
        </div>
      </div>
    </main>
  </div>
  </div>
)

export default App
